import { render, staticRenderFns } from "./notEngineer.vue?vue&type=template&id=4c113afe&scoped=true"
import script from "./notEngineer.vue?vue&type=script&lang=js"
export * from "./notEngineer.vue?vue&type=script&lang=js"
import style0 from "./notEngineer.vue?vue&type=style&index=0&id=4c113afe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c113afe",
  null
  
)

export default component.exports